// checkbox / switch / consent — anything whose value is a boolean.
import React from "react";
import { Checkbox, FormControlLabel, Switch, Typography } from "@mui/material";
import FieldFrame from "./FieldFrame";

const BooleanInput = ({ field, value, error, disabled, onChange }) => {
  const checked = !!value;
  const Control = field.type === "switch" ? Switch : Checkbox;

  return (
    <FieldFrame error={error} help={field.help} sx={{ mt: field.type === "consent" ? 1 : 2 }}>
      <FormControlLabel
        disabled={disabled}
        control={
          <Control
            checked={checked}
            onChange={(e) => onChange({ target: { value: e.target.checked } })}
            sx={{
              "&.Mui-checked": { color: "#C9A777" },
              "& .MuiSwitch-switchBase.Mui-checked": { color: "#C9A777" },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { bgcolor: "#C9A777" },
            }}
          />
        }
        label={
          <Typography
            sx={{
              color: "#3d322b",
              fontSize: field.type === "consent" ? "0.875rem" : "0.9375rem",
              lineHeight: 1.6,
            }}
          >
            {field.label}
            {field.required && <Typography component="span" sx={{ color: "#C9A777" }}> *</Typography>}
          </Typography>
        }
        sx={{ alignItems: "flex-start", m: 0, "& .MuiCheckbox-root": { pt: 0.25 } }}
      />
    </FieldFrame>
  );
};

export default BooleanInput;
